import { Component, OnDestroy, OnInit } from '@angular/core';
import { MeetingSchedulerStoreService } from '../data-providers/meeting-scheduler-store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'meeting-scheduler-meeting-type-list-view',
  templateUrl: './meeting-type-list-view.component.html',
  styleUrls: ['./meeting-type-list-view.component.scss'],
  standalone: false,
})
export class MeetingTypeListViewComponent implements OnInit, OnDestroy {
  selectedIndex = 0;
  defaultValue: boolean;
  subscription: Subscription;
  constructor(
    private readonly meetingSchedulerStoreService: MeetingSchedulerStoreService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {}
  ngOnInit() {
    this.subscription = this.route.queryParams.subscribe((params) => {
      if (params['defaults']) {
        this.defaultValue = params['defaults'];
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {},
        replaceUrl: true,
      });

      if (this.defaultValue) {
        this.selectedIndex = 3;
        this.meetingSchedulerStoreService.selectedTabEventTypeListView = 3;
      } else {
        this.selectedIndex = this.meetingSchedulerStoreService.selectedTabEventTypeListView;
      }
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onTabChange(index) {
    this.meetingSchedulerStoreService.selectedTabEventTypeListView = index;
  }
}
